import FeedIcon from './FeedIcon';

export default FeedIcon;
